import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { toast } from "sonner";
import { API, fmtErr } from "../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await API.post("/newsletter", { email });
      toast.success("You're on the list. Welcome to the family.");
      setEmail("");
    } catch (err) {
      toast.error(fmtErr(err));
    }
  };

  return (
    <footer className="border-t border-[#262626] bg-ink mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo.png" alt="Dressedin by Urbanz" className="h-12 w-12 object-contain" />
            <div className="font-display font-extrabold tracking-widest">
              <span className="gold-text">DRESSEDIN</span>
              <span className="block text-[9px] text-muted-foreground tracking-[0.35em]">BY URBANZ</span>
            </div>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Wear your identity. Streetwear energy, luxury polish — made for those who refuse to blend in.
          </p>
          <div className="mt-5 text-xs text-muted-foreground space-y-1.5" data-testid="footer-contact">
            <p>Shop no. 2, New Ashok Vihar, Near Avantika Hotel,<br />80 Feet Road, Ashoka Garden, Bhopal (M.P.)</p>
            <p><a href="mailto:urbanzfashion05@gmail.com" className="hover:text-gold transition-colors">urbanzfashion05@gmail.com</a></p>
            <p><a href="https://www.dressedinurbanz.com" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">www.dressedinurbanz.com</a></p>
          </div>
          <div className="flex gap-3 mt-5" data-testid="footer-socials">
            {[
              [Instagram, "https://instagram.com/dressedinbyurbanz", "instagram"],
              [Facebook, "https://facebook.com/dressedinbyurbanz", "facebook"],
              [Twitter, "https://x.com/dressedinbyurbanz", "x"],
            ].map(([Icon, href, label]) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
                data-testid={`social-${label}`}
                className="p-2.5 border border-[#262626] text-muted-foreground hover:text-gold hover:border-gold transition-colors">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold font-bold mb-4">Shop</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link className="hover:text-gold transition-colors" to="/shop?category=streetwear">Streetwear</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/shop?category=casual">Casual Wear</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/customize">Customize</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/shop">All Products</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold font-bold mb-4">Support</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link className="hover:text-gold transition-colors" to="/track">Track Order</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/account">My Account</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/cart">Cart</Link></li>
            <li><Link className="hover:text-gold transition-colors" to="/wishlist">Wishlist</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-gold font-bold mb-4">Join the drop list</h4>
          <p className="text-sm text-muted-foreground mb-3">Early access to limited drops. No spam.</p>
          <form onSubmit={subscribe} className="flex">
            <input data-testid="footer-newsletter-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="your@email.com"
              className="flex-1 min-w-0 bg-ink-surface border border-[#262626] px-3 py-2.5 text-sm outline-none focus:border-gold" />
            <button data-testid="footer-newsletter-btn" className="btn-gold px-4 text-xs font-bold uppercase tracking-wider">
              Join
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-[#262626] py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Dressedin by Urbanz. All rights reserved.
      </div>
    </footer>
  );
}
